import log, { type Logger } from 'loglevel';

let isEnabled = false;
const analyticsLoggers: Map<string, Logger> = new Map();

/**
 * Get a loglevel logger for use with Analytics code
 *
 * @param name Name for logger, prefixed to output
 * @internal
 */
export function getLogger(name: string): Logger {
  let logger = analyticsLoggers.get(name);
  if (logger === undefined) {
    logger = log.getLogger(prefix + name);

    // silent by default
    logger.setDefaultLevel(log.levels.SILENT);
    if (isEnabled) {
      logger.setLevel(log.levels.DEBUG);
    }

    analyticsLoggers.set(name, logger);
  }

  return logger;
}

/** Enable or disable logging across all Analytics loggers */
export function setAnalyticsLoggingEnabled(enabled: boolean): void {
  isEnabled = enabled;

  for (const logger of analyticsLoggers.values()) {
    if (isEnabled) {
      logger.setLevel(log.levels.DEBUG);
    } else {
      logger.resetLevel();
    }
  }
}

const prefix = 'Analytics.';
